import { LogLevel, PublicClientApplication } from '@azure/msal-browser'
import ConfigUtils from '../common/config-utils'

/**
 * Azure AD 認証で使用する MSAL (Microsoft 認証ライブラリ) の構成オブジェクト。
 */
export const msalConfig = {
  auth: {
    /**
     * Azure AD に登録されたアプリケーションのクライアント ID。
     * これは Azure AD 内でアプリケーションを一意に識別する識別子です。
     *
     * @type {string}
     */
    clientId: ConfigUtils.getConfigByKey('MSAL_CLIENT_ID'),

    /**
     * Azure AD の認証局 URL。これにより、アイデンティティプロバイダが決定されます。
     * Azure AD B2C の場合、これはカスタムドメインまたはディレクトリの URL である必要があります。
     *
     * @type {string}
     */
    authority: `https://${ConfigUtils.getConfigByKey('MSAL_AUTHORITY_DOMAIN')}/${ConfigUtils.getConfigByKey('MSAL_TENANT_ID')}`,

    /**
     * 信頼された機関のリスト。
     */
    knownAuthorities: ConfigUtils.getConfigByKey('MSAL_DOMAIN'),

    /**
     * 認証後にユーザーがリダイレクトされる URI。
     * 通常、アプリケーションのベース URL に設定されます。
     *
     * @type {string}
     */
    redirectUri: '/',

    /**
     * ログアウト後に遷移する URI。ユーザーはログアウト時にこの URI にリダイレクトされます。
     *
     * @type {string}
     */
    postLogoutRedirectUri: '/',

    /**
     * ログイン後に MSAL が元のリクエスト URL に遷移するかどうかを判定するフラグ。
     * `false` に設定すると、ユーザーは `redirectUri` にリダイレクトされます。
     *
     * @type {boolean}
     */
    navigateToLoginRequestUrl: false
  },
  cache: {
    /**
     * 認証キャッシュを保存する場所。`localStorage` または `sessionStorage` のいずれかを選択します。
     *
     * @type {'localStorage' | 'sessionStorage'}
     */
    cacheLocation: 'localStorage',

    /**
     * 認証状態をクッキーに保存するオプション。IE11 との互換性のため、または必要に応じてクロスブラウザ対応のために推奨されます。
     *
     * @type {boolean}
     */
    storeAuthStateInCookie: true
  },
  system: {
    /**
     * 認証中のポップアップ URL ハッシュの極間の時間間隔 (ミリ秒単位)。
     */
    pollIntervalMilliseconds: 0,
    loggerOptions: {
      /**
       * MSAL のログメッセージを処理するコールバック関数。ログレベルと PII（個人情報）に基づいて処理されます。
       *
       * @param level - ログレベル（例：Error や Warning）、ログメッセージの重大度を示します。
       * @param message - 表示するログメッセージ。
       * @param containsPii - ログメッセージに個人情報（PII）が含まれているかどうかを示すフラグ。
       */
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        if (level === LogLevel.Error || level === LogLevel.Warning) {
          console.log(message)
        }
      }
    }
  }
}

// 構成オブジェクトを使用して MSAL の新しいインスタンスを作成します。
const msalInstance = new PublicClientApplication(msalConfig)

/**
 * ユーザーのメールアドレスへのアクセスを要求するスコープ。
 */
export const loginRequest = {
  scopes: ['email']
}

/**
 * ユーザーのメールアドレスと名前へのアクセスを要求するスコープ。
 */
export const popupWindowAttributes = {
  popupSize: {
    width: 500,
    height: 600
  },
  PopupPosition: {
    // 垂直方向の中央を計算 = ブラウザウィンドウの高さ / 2 - ポップアップの高さ / 2
    top: window.innerHeight / 2 - 600 / 2,
    // 水平方向の中央を計算 = ブラウザウィンドウの幅 / 2 - ポップアップの幅 / 2
    left: window.innerWidth / 2 - 500 / 2
  }
}

export default msalInstance



// WEBPACK FOOTER //
// ./src/entra-login/entra.config.js